import { TRASHIE_GA_TAG_ID } from '../config/config';

import { isProd, isTrashieApp } from '../../../config/config';

const tagId = isProd() ? TRASHIE_GA_TAG_ID.PRODUCTION : TRASHIE_GA_TAG_ID.STAGING;
const configOptions = isProd() ? '' : ', { debug_mode: true }';
// Grant analytics_storage in dev/staging so DebugView works without the banner
const consentDefault = isProd()
  ? ''
  : "gtag('consent', 'default', { analytics_storage: 'granted' });";
const script = isTrashieApp()
  ? `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
${consentDefault}gtag('config', '${tagId}'${configOptions});`
  : null;

export default script;
